module.exports = __webpack_public_path__ + "img/arrowdown.f8d7f8c8.svg";